import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {DictionaryFuelPriceIndexRecord} from "../types/dictionary-fuel-price-index-record";
import {DictionaryFuelPriceIndexAddRequest} from "../types/dictionary-fuel-price-index-add-request";

@Injectable({
  providedIn: 'root',
})
export class DictionaryFuelPriceIndexService {
  private url: string = '/api/dictionary/fuel-price-index';

  constructor(private http: HttpClient) {}

  getAll(): Observable<DictionaryFuelPriceIndexRecord[]> {
    return this.http.get<DictionaryFuelPriceIndexRecord[]>(this.url);
  }

  getById(id: number): Observable<DictionaryFuelPriceIndexRecord[]> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<DictionaryFuelPriceIndexRecord[]>(this.url, { params });
  }

  add(parameter: DictionaryFuelPriceIndexAddRequest): Observable<any> {
    return this.http.post<any>(this.url, parameter);
  }

  delete(id: number): Observable<any> {
    const parameter = { id: id };
    return this.http.delete<any>(this.url, { body: parameter });
  }
}
